const toBoolean = value => (value === 'true' ? true : false);

export default toBoolean;
